import React from "react";

import {
  Box,
  Flex,
  Heading,
  Text,
  Button,
  Link as ChakraLink,
  Center,
} from "@chakra-ui/react";
import Link from "next/link"; // Örnek bir router kütüphanesi



function StartupSolutions() {
  return <>StartupSolutions</>;
}

export default StartupSolutions;
